import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { parseDateTime, DateTimeExtensions_toShortDate } from "../../Utils.js";
import { toFail, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { list_type, enum_type, uint8_type, option_type, string_type, record_type, int32_type, union_type, class_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { MonthModule_fromInt, MonthModule_toTranslation } from "../../DomainTypes.js";
import { toString, month } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { length, sumBy, map } from "../../fable_modules/fable-library.3.7.20/List.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { op_Addition, fromParts } from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import Decimal from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import { op_Addition as op_Addition_1, fromInt, fromInteger } from "../../fable_modules/fable-library.3.7.20/Long.js";
import { List_groupBy } from "../../fable_modules/fable-library.3.7.20/Seq2.js";
import { stringHash } from "../../fable_modules/fable-library.3.7.20/Util.js";

export function getCallsByDateUrl(clientNr, contractNr, dateFrom, dateTo, toSlk) {
    let arg_2, arg_1;
    const format = toSlk ? "slk" : "json";
    return ValidatedUrlModule_create(new UrlKind(0, (arg_2 = DateTimeExtensions_toShortDate(dateTo), (arg_1 = DateTimeExtensions_toShortDate(dateFrom), toText(printf("/Data/R35/%i/%s/%s/?contracts=%i\u0026format=%s"))(clientNr)(arg_1)(arg_2)(contractNr)(format)))));
}

export function getNonInvoicedCallsUrl(clientNr, contractNr, toSlk) {
    const format = toSlk ? "slk" : "json";
    return ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Data/R35/NonInvoicedTraffic/%i/%i/?format=%s"))(clientNr)(contractNr)(format)));
}

export class TrafficChoice extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Choose", "NotInvoicedTraffic", "Date"];
    }
}

export function TrafficChoice$reflection() {
    return union_type("Containers.Traffic.Model.TrafficChoice", [], TrafficChoice, () => [[], [], [["Item", class_type("System.DateTime")]]]);
}

const TrafficChoiceModule_notInvoicedTraffic = "NotInvoicedTraffic";

export function TrafficChoiceModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return TrafficChoiceModule_notInvoicedTraffic;
        }
        case 2: {
            return DateTimeExtensions_toShortDate(_arg.fields[0]);
        }
        default: {
            return "";
        }
    }
}

export function TrafficChoiceModule_fromString(_arg) {
    switch (_arg) {
        case "": {
            return new TrafficChoice(0);
        }
        case TrafficChoiceModule_notInvoicedTraffic: {
            return new TrafficChoice(1);
        }
        default: {
            const x_2 = _arg;
            const matchValue = parseDateTime(x_2);
            if (matchValue != null) {
                return new TrafficChoice(2, matchValue);
            }
            else {
                return toFail(printf("[TrafficChoice] Cannot date-parse string \u0027%s\u0027"))(x_2);
            }
        }
    }
}

function TrafficChoiceModule_toYearMonth(getTranslation, date) {
    const translatedMonth = MonthModule_toTranslation(getTranslation, MonthModule_fromInt(month(date)));
    const year = toString(date, "yyyy");
    return toText(printf("%s %s"))(year)(translatedMonth);
}

export function TrafficChoiceModule_toTranslation(getTranslation, _arg) {
    switch (_arg.tag) {
        case 1: {
            return getTranslation("CustomerContract.Invoicee.Subscriptions.Traffic.NotInvoicedTraffic");
        }
        case 2: {
            return TrafficChoiceModule_toYearMonth(getTranslation, _arg.fields[0]);
        }
        default: {
            return getTranslation("Common.Choose");
        }
    }
}

export class YearMonth extends Record {
    constructor(Year, Month) {
        super();
        this.Year = (Year | 0);
        this.Month = (Month | 0);
    }
}

export function YearMonth$reflection() {
    return record_type("Containers.Traffic.Model.YearMonth", [], YearMonth, () => [["Year", int32_type], ["Month", int32_type]]);
}

export class CallByDate extends Record {
    constructor(B_Number, BillingNumber, StartTime, Units, BearerType, BillingCharge, Description, InvoiceNr, InvoiceDate, OriginCost) {
        super();
        this.B_Number = B_Number;
        this.BillingNumber = BillingNumber;
        this.StartTime = StartTime;
        this.Units = Units;
        this.BearerType = BearerType;
        this.BillingCharge = BillingCharge;
        this.Description = Description;
        this.InvoiceNr = InvoiceNr;
        this.InvoiceDate = InvoiceDate;
        this.OriginCost = OriginCost;
    }
}

export function CallByDate$reflection() {
    return record_type("Containers.Traffic.Model.CallByDate", [], CallByDate, () => [["B_Number", option_type(string_type)], ["BillingNumber", option_type(string_type)], ["StartTime", class_type("System.DateTime")], ["Units", class_type("System.Int64")], ["BearerType", string_type], ["BillingCharge", option_type(class_type("System.Decimal"))], ["Description", string_type], ["InvoiceNr", option_type(class_type("System.Decimal"))], ["InvoiceDate", option_type(class_type("System.DateTime"))], ["OriginCost", option_type(class_type("System.Decimal"))]]);
}

export function BearerTypeModule_toString(_arg) {
    switch (_arg) {
        case 0: {
            return "VOICE";
        }
        case 1: {
            return "VOICE PREMIUM";
        }
        case 2: {
            return "VOICE FREE";
        }
        case 4: {
            return "SMS";
        }
        case 5: {
            return "SMS PREMIUM";
        }
        case 11: {
            return "DATA";
        }
        case 12: {
            return "MMS";
        }
        case 14: {
            return "PREMIUM";
        }
        case 15: {
            return "OTHER";
        }
        default: {
            return toFail(printf("No such Bearer"));
        }
    }
}

export function BearerTypeModule_fromString(_arg) {
    switch (_arg) {
        case "VOICE PREMIUM": {
            return 1;
        }
        case "VOICE FREE": {
            return 2;
        }
        case "SMS PREMIUM": {
            return 5;
        }
        case "VOICE": {
            return 0;
        }
        case "SMS": {
            return 4;
        }
        case "DATA": {
            return 11;
        }
        case "MMS": {
            return 12;
        }
        case "PREMIUM": {
            return 14;
        }
        case "OTHER": {
            return 15;
        }
        default: {
            return toFail(printf("No such Bearer")) | 0;
        }
    }
}

export class SummaryRow extends Record {
    constructor(BearerType, Units, Price, OriginCost) {
        super();
        this.BearerType = (BearerType | 0);
        this.Units = Units;
        this.Price = Price;
        this.OriginCost = OriginCost;
    }
}

export function SummaryRow$reflection() {
    return record_type("Containers.Traffic.Model.SummaryRow", [], SummaryRow, () => [["BearerType", enum_type("Containers.Traffic.Model.BearerType", uint8_type, [["Voice", 0], ["Sms", 4], ["Data", 11], ["Mms", 12], ["Premium", 14], ["Other", 15], ["VoicePremium", 1], ["VoiceFree", 2], ["SmsPremium", 5]])], ["Units", class_type("System.Int64")], ["Price", class_type("System.Decimal")], ["OriginCost", class_type("System.Decimal")]]);
}

export function getSummary(callsByDate) {
    return map((tupledArg) => {
        const callsByDate_1 = tupledArg[1];
        const bearerType = BearerTypeModule_fromString(tupledArg[0]) | 0;
        const price = sumBy((c) => defaultArg(c.BillingCharge, fromParts(0, 0, 0, false, 1)), callsByDate_1, {
            GetZero: () => (new Decimal(0)),
            Add: op_Addition,
        });
        const originCost = sumBy((c_1) => defaultArg(c_1.OriginCost, fromParts(0, 0, 0, false, 1)), callsByDate_1, {
            GetZero: () => (new Decimal(0)),
            Add: op_Addition,
        });
        return new SummaryRow(bearerType, ((bearerType === 4) ? true : (bearerType === 12)) ? fromInteger(length(callsByDate_1), false, 2) : sumBy((c_2) => c_2.Units, callsByDate_1, {
            GetZero: () => fromInt(0),
            Add: op_Addition_1,
        }), price, originCost);
    }, List_groupBy((c_3) => c_3.BearerType, callsByDate, {
        Equals: (x_3, y_3) => (x_3 === y_3),
        GetHashCode: stringHash,
    }));
}

export class CallsByDateResponse extends Record {
    constructor(Result) {
        super();
        this.Result = Result;
    }
}

export function CallsByDateResponse$reflection() {
    return record_type("Containers.Traffic.Model.CallsByDateResponse", [], CallsByDateResponse, () => [["Result", list_type(CallByDate$reflection())]]);
}

